import "./DatetimePicker.css";
import React from "react";
import DatePicker from "react-datepicker";
import moment from "moment";
import "moment/locale/es";
import "react-datepicker/dist/react-datepicker.css";

import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import {
  clearShortcut,
  setStartDate,
  setEndDate,
  setToday,
  setYesterday,
  setCurrentWeek,
  setLast30Days,
  setPreviousMonth,
  setPastPreviousMonth
} from "./../../modules/dates";

import { getPast2MonthsIndexes } from "./../../utilities/datesFormatter";

import Grid from "material-ui/Grid";
import IconButton from "material-ui/IconButton";
import TodayIcon from "material-ui-icons/Today";
import Typography from "material-ui/Typography";
import Input from "material-ui/Input";
import { MenuItem } from "material-ui/Menu";
import { FormControl } from "material-ui/Form";
import Select from "material-ui/Select";

class Custom extends React.Component {
  render() {
    let text;
    const { lang, date } = this.props;
    if (!date) {
      text = this.props.text;
    } else {
      //text = moment(this.props.date).format("DD-MM-YYYY HH:mm:ss");
      const day = lang[`Day${date.day() + 1}`];
      const formatted = moment(date).format("DD-MM-YYYY HH:mm:ss");
      text = `${day} ${formatted}`;
    }
    return (
      <div className="custom" onClick={this.props.onClick}>
        <IconButton aria-label="Delete">
          <TodayIcon onClick={this.props.onClick} />
        </IconButton>
        <Typography variant="body2" gutterBottom>
          {text}
        </Typography>
      </div>
    );
  }
}

class DatetimePicker extends React.Component {
  handleStartDateChange = date => {
    date.seconds(0);
    this.props.setStartDate(date);
  };

  handleEndDateChange = date => {
    date.seconds(0);
    this.props.setEndDate(date);
  };

  handleShortcutChange = event => {
    switch (event.target.value) {
      case 1:
        this.props.clearShortcut();
        break;
      case 2:
        this.props.setToday();
        break;
      case 3:
        this.props.setYesterday();
        break;
      case 4:
        this.props.setCurrentWeek();
        break;
      case 5:
        this.props.setLast30Days();
        break;
      case 6:
        this.props.setPreviousMonth();
        break;
      case 7:
        this.props.setPastPreviousMonth();
        break;
      default:
        break;
    }
  };

  render() {
    const { startDate, endDate, selectedShortcut, lang } = this.props;
    const locale = lang._code;
    const last2Months = getPast2MonthsIndexes();
    return (
      <Grid container spacing={24}>
        <Grid
          item
          xs={12}
          sm={4}
          md={4}
          lg={4}
          xl={4}
          className="grid-item shortcut-container"
        >
          <Grid container spacing={24}>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <Typography align="center" variant="subheading" color="primary">
                <b>{lang.ConsultaRapida}</b>
              </Typography>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <FormControl className="form-ctrl">
                <Select
                  value={selectedShortcut ? selectedShortcut : ""}
                  onChange={this.handleShortcutChange}
                  input={<Input name="date-shortcut" id="date-shortcut" />}
                >
                  <MenuItem value={1}>
                    <em>{lang.Personalizada}</em>
                  </MenuItem>
                  <MenuItem value={2}>{lang.Hoy}</MenuItem>
                  <MenuItem value={3}>{lang.Ayer}</MenuItem>
                  <MenuItem value={4}>{lang.SemanaEnCurso}</MenuItem>
                  <MenuItem value={5}>{lang.Ultimos30Dias}</MenuItem>
                  <MenuItem value={6}>
                    {lang[`Month${last2Months.pastMonth}`]}
                  </MenuItem>
                  <MenuItem value={7}>
                    {lang[`Month${last2Months.beforePastMonth}`]}
                  </MenuItem>
                </Select>
              </FormControl>
            </Grid>
          </Grid>
        </Grid>
        <Grid
          item
          xs={6}
          sm={4}
          md={4}
          lg={4}
          xl={4}
          className="grid-item datetime-picker"
        >
          <Grid container spacing={24}>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <Typography align="center" variant="subheading" color="primary">
                <b>{lang.FechaInicial}</b>
              </Typography>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <DatePicker
                selected={startDate ? moment(startDate) : startDate}
                onChange={this.handleStartDateChange}
                showTimeSelect
                minDate={moment().subtract(3, "month")}
                maxDate={moment()}
                dateFormat="L"
                withPortal
                customInput={
                  <Custom
                    date={startDate}
                    text={lang.FechaInicial}
                    lang={lang}
                  />
                }
                locale={locale}
                timeIntervals={30}
                shouldCloseOnSelect={true}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid
          item
          xs={6}
          sm={4}
          md={4}
          lg={4}
          xl={4}
          className="grid-item datetime-picker"
        >
          <Grid container spacing={24}>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <Typography align="center" variant="subheading" color="primary">
                <b>{lang.FechaFinal}</b>
              </Typography>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <DatePicker
                selected={endDate ? moment(endDate) : endDate}
                onChange={this.handleEndDateChange}
                showTimeSelect
                minDate={moment().subtract(3, "month")}
                maxDate={moment()}
                dateFormat="L"
                withPortal
                customInput={
                  <Custom date={endDate} text={lang.FechaFinal} lang={lang} />
                }
                locale={locale}
                timeIntervals={30}
                shouldCloseOnSelect={true}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    );
  }
}

const mapStateToProps = state => ({
  lang: state.internationalization.lang,
  startDate: state.dates.startDate,
  endDate: state.dates.endDate,
  selectedShortcut: state.dates.selectedShortcut
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      clearShortcut,
      setToday,
      setYesterday,
      setCurrentWeek,
      setLast30Days,
      setPreviousMonth,
      setPastPreviousMonth,
      setStartDate,
      setEndDate
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(DatetimePicker);



// WEBPACK FOOTER //
// ./src/components/DatetimePicker/DatetimePicker.js